<div class="wrap">

  <form [formGroup]="createUserForm" (ngSubmit)="onSubmit()">
    <h2>Nouvel utilisateur : </h2>
    <mat-form-field appearance="outline">
      <mat-label>User</mat-label>
      <input type="text" matInput formControlName="user">
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Email</mat-label>
      <input type="email" matInput formControlName="email">
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Password</mat-label>
      <input type="password" matInput formControlName="password">
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Confirm password</mat-label>
      <input type="password" matInput formControlName="confirmPassword">

    </mat-form-field>
    <div class="btn_action">

      <button [routerLink]="['/login']" routerLinkActive="router-link-active" class="cancel"
        type="button">Annuler</button>
      <button type="submit" mat-raised-button color="primary"
        [disabled]="createUserForm.invalid">Confirmer</button><br><br>
    </div>
  </form>
</div>